export default __webpack_public_path__ + "static/image-808-b985845085dd37853a2fe41be12b8d5e.png";